import React from 'react';

interface ProgressBarProps {
  value: number;
  showLabel?: boolean;
  size?: 'sm' | 'md';
  color?: 'primary' | 'green' | 'amber' | 'red';
}

export default function ProgressBar({
  value,
  showLabel = false,
  size = 'sm',
  color = 'primary',
}: ProgressBarProps) {
  const heightClass = size === 'sm' ? 'h-1.5' : 'h-2.5';
  const colorClass =
    color === 'green' ?'bg-green-500'
      : color === 'amber' ?'bg-amber-500'
      : color === 'red' ?'bg-red-500' :'bg-primary';

  return (
    <div className="flex items-center gap-2">
      <div className={`flex-1 bg-muted rounded-full overflow-hidden ${heightClass}`}>
        <div
          className={`${heightClass} ${colorClass} rounded-full progress-bar-fill`}
          style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
        />
      </div>
      {showLabel && (
        <span className="text-xs font-semibold text-muted-foreground font-tabular w-8 text-right">
          {value}%
        </span>
      )}
    </div>
  );
}